var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionroxo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.88 20.2045C15.9949 20.2045 17.6899 21.916 17.6899 24.0459V29.1594C17.6899 31.2744 15.9949 32.9994 13.88 32.9994H8.80998C6.70999 32.9994 5 31.2744 5 29.1594V24.0459C5 21.916 6.70999 20.2045 8.80998 20.2045H13.88ZM31.19 20.2045C33.29 20.2045 35 21.916 35 24.0459V29.1594C35 31.2744 33.29 32.9994 31.19 32.9994H26.12C24.0051 32.9994 22.3101 31.2744 22.3101 29.1594V24.0459C22.3101 21.916 24.0051 20.2045 26.12 20.2045H31.19ZM13.88 3C15.9949 3 17.6899 4.72499 17.6899 6.84148V11.955C17.6899 14.0849 15.9949 15.7949 13.88 15.7949H8.80998C6.70999 15.7949 5 14.0849 5 11.955V6.84148C5 4.72499 6.70999 3 8.80998 3H13.88ZM31.19 3C33.29 3 35 4.72499 35 6.84148V11.955C35 14.0849 33.29 15.7949 31.19 15.7949H26.12C24.0051 15.7949 22.3101 14.0849 22.3101 11.955V6.84148C22.3101 4.72499 24.0051 3 26.12 3H31.19Z",
    fill: "#54398E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionroxo);
export default __webpack_public_path__ + "static/media/sessionroxo.ccb0bb782ac742ed0012c6cfa90216d3.svg";
export { ForwardRef as ReactComponent };